import { AddAlt, DirectionMerge } from '@carbon/icons-react';
import { featureFlag, useFeatureFlag } from '@routable/feature-configs';
import { Menu } from '@routable/gross-ds';
import React from 'react';
import { VendorsCannotReceiveInvoicesText } from 'complexComponents';
import { isItemKindReceivable } from 'helpers/items';
import { getVendorOrCustomerTitleFromItemKind } from 'helpers/partnerships';
import { getAddPartnershipButtonTooltipText, getMergePartnershipButtonTooltipText } from '../helpers/text';
const RequiresMatchPopoverOptions = ({ isLoading, item, onAdd, onMerge }) => {
    const vendorsPayablesOnlyEnabled = useFeatureFlag(featureFlag.Enum.global_only_vendors_payables_only);
    const isMergeDisabled = vendorsPayablesOnlyEnabled && isItemKindReceivable(item);
    return (React.createElement(Menu, { label: "Update", loading: isLoading, placement: "bottom", size: "small" },
        React.createElement(Menu.Item, { icon: React.createElement(AddAlt, null), onAction: onAdd, tooltip: { position: 'left', tooltip: getAddPartnershipButtonTooltipText(item) } }, `Add as ${getVendorOrCustomerTitleFromItemKind(item.kind)}`),
        React.createElement(Menu.Item, { disabled: isMergeDisabled, icon: React.createElement(DirectionMerge, null), onAction: onMerge, tooltip: {
                position: 'left',
                tooltip: isMergeDisabled ? React.createElement(VendorsCannotReceiveInvoicesText, null) : getMergePartnershipButtonTooltipText(item),
            } }, "Merge")));
};
export default RequiresMatchPopoverOptions;
